// extracted by mini-css-extract-plugin
export var dropdown = "_hs-0";
export var imagePlaceholder = "_hs-2";
export var imageWrapper = "_hs-3";
export var productImage = "_hs-1";
export var truncateContainer = "_hs-4";
export var truncateText = "_hs-5";